namespace $ {

	export type $shm_projects_release_notes = {
		previous_version: string | null
		prerelease_ids: readonly string[]
		generated_at: number
		technical: string
		product: string
		executive: string
		user: string
	}

	export type $shm_projects_release_notes_source = {
		project: string
		version: string
		previous_version: string | null
		prereleases: readonly {
			id: string
			project?: string
			version: string
			date: string
			changes: unknown
		}[]
	}

	export function $shm_projects_release_notes_source(
		project: string,
		version: string,
		history: readonly { id: string, version: string, date: string, stage: string, changes: unknown }[],
	): $shm_projects_release_notes_source {
		const compare = ( left: string, right: string )=> left.localeCompare( right, 'en', { numeric: true } )
		const previous = history.filter( item => item.stage === 'Релиз' && compare( item.version, version ) < 0 )
			.sort( ( a, b )=> compare( b.version, a.version ) )[0]
		const seen = new Set<string>()
		const prereleases = history.filter( item => item.stage === 'Пререлиз'
			&& compare( item.version, version ) <= 0
			&& ( !previous || compare( item.version, previous.version ) > 0 ) )
			.sort( ( a, b )=> compare( a.version, b.version ) )
			.filter( item => !seen.has( item.version ) && Boolean( seen.add( item.version ) ) )
			.map( ( { id, version, date, changes } )=> ( { id, project, version, date, changes } ) )
		if( !prereleases.some( item => item.version === version ) ) throw new Error( `Нет описания пререлиза v${ version }` )
		return { project, version, previous_version: previous?.version ?? null, prereleases }
	}

	export function $shm_projects_release_notes_parse( text: string, source: $shm_projects_release_notes_source ): $shm_projects_release_notes {
		const value = JSON.parse( text )
		const fields = [ 'technical', 'product', 'executive', 'user' ] as const
		for( const field of fields ) {
			if( !( typeof value?.[field] === 'string' && value[field].trim() )
				&& !( Array.isArray( value?.[field] ) && $shm_projects_changes_format( value[field] ) ) ) {
				throw new Error( `Список изменений: не заполнено представление ${ field }` )
			}
		}
		const formatted = ( field: typeof fields[number] )=> Array.isArray( value[field] )
			? $shm_projects_changes_format( value[field] )
			: String( value[field] ).trim()
		return {
			previous_version: source.previous_version,
			prerelease_ids: source.prereleases.map( item => item.id ),
			generated_at: Date.now(),
			technical: formatted( 'technical' ), product: formatted( 'product' ),
			executive: formatted( 'executive' ), user: formatted( 'user' ),
		}
	}

}
